export const fetchLevelData = async (productName: any, setlevelList: any) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_BLOB_STORAGE}/content/${process.env.REACT_APP_OSCAR_ENV}/product_type/${productName}/default.json`);
        const data = await response.json();
        const levelData = data?.level;
        if (levelData) setlevelList(levelData);
      } catch (error) {
        console.log(error);
      }
}

export const calculateOverallUnitsCompletion = (seperatedUnitsList: Array<any>) => {
    for (let i = 0; i < seperatedUnitsList.length; i++) {
      for (let j = 0; j < seperatedUnitsList[i].units.length; j++) {
        seperatedUnitsList[i].prework += seperatedUnitsList[i].units[j].prework;
        seperatedUnitsList[i].totalprework += seperatedUnitsList[i].units[j].totalprework;
        seperatedUnitsList[i].sessions += seperatedUnitsList[i].units[j].sessions;
        seperatedUnitsList[i].totalsessions += seperatedUnitsList[i].units[j].totalsessions;
      }
    }
    return seperatedUnitsList;
  };

export const fillPartsArray = (partsList: any, structuredUnParted: any, filledPartList: any) => {
  let notedDownTitles: any = [];
  for (let j = 0; j < structuredUnParted.courses.length; j++) {
    for (let k = 0; k < structuredUnParted.courses[j].skillcourses.length; k++) {
      partsList.map((part: any) => {
        if (part.courseparttitle === structuredUnParted.courses[j].skillcourses[0].courseparttitle) {
          if (notedDownTitles.indexOf(structuredUnParted.courses[j].skilltitle) === -1) {
            notedDownTitles.push(structuredUnParted.courses[j].skilltitle);
            part.courses.push(structuredUnParted.courses[j]);
          }
        }
      });
    }
  }
  let newFilledPartList = partsList;
  return newFilledPartList;
};

export const generatePartSprint = (structuredUnParted: any, isSolo = false, filledPartList: any) => {
  let partsList = [];
  let partsStringList = [];
  for (let j = 0; j < structuredUnParted.courses.length; j++) {
    for (let k = 0; k < structuredUnParted.courses[j].skillcourses.length; k++) {
      if (partsStringList.indexOf(structuredUnParted.courses[j].skillcourses[0].courseparttitle) === -1) {
        partsStringList.push(structuredUnParted.courses[j].skillcourses[0].courseparttitle);
        let partsObj = {
          level: structuredUnParted.courses[j].skilllevel,
          courseparttitle: structuredUnParted.courses[j].skillcourses[0].courseparttitle,
          courses: [],
          total: [],
        };
        partsList.push(partsObj);
      }
    }
  }
  return fillPartsArray(partsList, structuredUnParted, filledPartList);
};